import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCart, removeCartItem } from "../services/api";

export default function Cart() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const data = await getCart();
      setItems(data);
    } catch (e) {
      alert("Gagal load cart. Pastikan sudah login.");
    }
  };

  useEffect(() => {
    load();
  }, []);

  const total = useMemo(() => {
    return items.reduce((sum, it) => {
      const price = Number(it.product?.price || 0);
      return sum + price * Number(it.qty || 0);
    }, 0);
  }, [items]);

  const removeItem = async (id) => {
    await removeCartItem(id);
    await load();
  };

  return (
    <div>
      <h2>Keranjang</h2>
      {items.length === 0 ? (
        <div>
          Keranjang kosong. <Link to="/">Belanja dulu</Link>
        </div>
      ) : (
        <>
          {items.map((it) => (
            <div key={it.id} style={{ borderBottom: "1px solid #eee", padding: "8px 0" }}>
              <div>
                <b>{it.product?.name}</b>
              </div>
              <div>Qty: {it.qty}</div>
              <div>Harga: Rp {it.product?.price}</div>
              <button onClick={() => removeItem(it.id)}>Hapus</button>
            </div>
          ))}
          <h3>Total: Rp {total}</h3>
          <button onClick={() => navigate("/checkout")}>Checkout</button>
        </>
      )}
    </div>
  );
}
